import { useState } from 'react';
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import './ContactSection.css';

const CONTACT_INFOS = [
  {
    icon: <PhoneOutlined />,
    label: 'Téléphone',
    value: '(+216) 36 722 922',
    href: 'tel:+21636722922',
  },
  {
    icon: <MailOutlined />,
    label: 'Email',
    value: 'contact@batilink.tn',
    href: 'mailto:contact@batilink.tn',
  },
  {
    icon: <EnvironmentOutlined />,
    label: 'Adresse',
    value: 'Imm. Avicenne, en face hôpital Farhat Hached — Sousse',
  },
 
];

function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Échec de l\'envoi');

      setSubmitMessage('✓ Votre message a été envoyé ! Nous vous répondons rapidement.');
      setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
    } catch (err) {
      console.error('[ContactSection] envoi échoué', err);
      setSubmitMessage('❌ Erreur lors de l\'envoi. Réessayez ou écrivez à contact@batilink.tn');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 12000);
    }
  };

  return (
    <section className="contact-section contact-section-bg" id="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Une question ? On vous répond.</h2>
          <p className="section-subtitle">Notre équipe est disponible pour vous accompagner dans votre projet.</p>
        </div>

        <div className="contact-layout">
          {/* Colonne infos */}
          <div className="contact-infos">
            {CONTACT_INFOS.map((info) => {
              const inner = (
                <>
                  <span className="contact-info-ic">{info.icon}</span>
                  <div className="contact-info-body">
                    <span className="contact-info-label">{info.label}</span>
                    <span className="contact-info-value">{info.value}</span>
                  </div>
                </>
              );
              return info.href ? (
                <a key={info.label} href={info.href} className="contact-info-card">
                  {inner}
                </a>
              ) : (
                <div key={info.label} className="contact-info-card contact-info-card--static">
                  {inner}
                </div>
              );
            })}
          </div>

          {/* Colonne formulaire */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-form-row">
              <input
                type="text"
                name="name"
                placeholder="Nom complet *"
                required
                className="contact-input"
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Téléphone"
                className="contact-input"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <input
              type="email"
              name="email"
              placeholder="Email *"
              required
              className="contact-input"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              type="text"
              name="subject"
              placeholder="Sujet *"
              required
              className="contact-input"
              value={formData.subject}
              onChange={handleChange}
            />

            <textarea
              name="message"
              placeholder="Message *"
              required
              rows="5"
              className="contact-textarea"
              value={formData.message}
              onChange={handleChange}
            />

            {submitMessage && (
              <div className="contact-form-msg">{submitMessage}</div>
            )}

            <button type="submit" className="contact-submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Envoi en cours…' : 'Envoyer le message'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
